import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './header';
import LeftBar from './leftbar';
import Footer from './footer';

function Index() {
    const location = useLocation();

    return (
        <div>
            <Header />
            <LeftBar />
            {/* Adding location.key forces the Outlet to entirely remount its matched components on every navigation,
             preventing stale data when the user uses the browser's 'Back' button. */}
            <Outlet key={location.key} />
            <Footer />
        </div>
    );
}

export default Index;
